import {createContext, useContext, type ReactNode} from 'react';

import {browserWebAuthnClient, type WebAuthnClient} from './webauthn.js';

/**
 * Injeção do cliente WebAuthn pela árvore.
 *
 * O default é o navegador de verdade: quem NÃO injeta nada recebe a cerimônia
 * real. Só o teste injeta um dublê, pelo mesmo caminho que o `dataSource` já
 * usa no `App`. O default no próprio contexto evita um provider obrigatório
 * que todo teste antigo teria que montar.
 */
const WebAuthnContext = createContext<WebAuthnClient>(browserWebAuthnClient);

export const WebAuthnProvider = ({
  client,
  children,
}: {
  client: WebAuthnClient;
  children: ReactNode;
}) => (
  <WebAuthnContext.Provider value={client}>{children}</WebAuthnContext.Provider>
);

export const useWebAuthn = (): WebAuthnClient => useContext(WebAuthnContext);
